import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Configuration } from './../configuration/configuration';
import { AuthService } from '../services/acceso/auth.service';
import { PathRoutes } from '../configuration/pathRoutes';

@Injectable()
export class NoIfAuthorizatedGuard implements CanActivate {
  constructor(
    private _router: Router,
    private _authService: AuthService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {   

    if ( this._authService.isLoggedIn() && state.url !== `/${PathRoutes.login}`) {
      this._router.navigate([PathRoutes.home]);
      return false;
    }

    return true;
  }
}
